export class NgEnter implements ng.IDirective {
  public restrict = 'A';

  public link(scope: ng.IScope, elem: JQuery, attrs: ng.IAttributes) {

    elem.bind("keydown keypress", function (event) {
      if(event.which === 13) {
        scope.$apply(function (){
            scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    });
  }
}
